import { Head } from "@inertiajs/react"
import { ApiDocs } from "@/components/api-docs/ApiDocs"

export default function ApiDocsPage() {
  return (
    <>
      <Head title="API docs">
        <meta
          name="description"
          content="Public reference for every Tubery API endpoint — authentication, parameters, request/response shapes, and example requests."
        />
        <meta property="og:title" content="API docs" />
        <meta
          property="og:description"
          content="Public reference for every Tubery API endpoint — authentication, parameters, request/response shapes, and example requests."
        />
      </Head>
      <ApiDocs />
    </>
  )
}
